import { render, staticRenderFns } from "./SolarNova3.vue?vue&type=template&id=578b3308"
import script from "./SolarNova3.vue?vue&type=script&lang=js"
export * from "./SolarNova3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports